export default {
  CATEGORIES: 'categories',
  PURPOSES: 'purposes',
  VENDORS: 'vendors',
}
